import React from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowRight, Calendar, User } from "lucide-react";
import PageTitle from "../components/PageTitle";
import { articles } from "../data/mock";

export default function ArticleDetail() {
  const { slug } = useParams();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <div>
        <PageTitle title="Article Not Found" crumbs={[{ to: "/patient-education", label: "Patient Education" }]} />
        <div className="max-w-3xl mx-auto px-4 py-20 text-center">
          <p className="text-gray-600 mb-6">The article you are looking for does not exist.</p>
          <Link to="/patient-education" className="inline-flex items-center gap-2 bg-[#b81d24] text-white px-6 py-3 rounded-full font-bold">Back to Articles <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </div>
    );
  }

  const others = articles.filter((a) => a.slug !== article.slug);

  return (
    <div>
      <PageTitle title={article.title} crumbs={[{ to: "/patient-education", label: "Patient Education" }, { label: "Article" }]} />
      <section className="py-16 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="rounded-2xl overflow-hidden mb-8 shadow-md">
            <img src={article.image} alt={article.title} className="w-full h-80 object-cover" />
          </div>
          <div className="flex items-center gap-5 text-sm text-gray-500 mb-4">
            <span className="flex items-center gap-2"><Calendar className="w-4 h-4 text-[#b81d24]" /> {article.day} {article.month}</span>
            <span className="flex items-center gap-2"><User className="w-4 h-4 text-[#b81d24]" /> {article.author}</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6">{article.title}</h2>
          {article.body.map((p, i) => (
            <p key={i} className="text-gray-700 leading-relaxed mb-4 text-[17px]">{p}</p>
          ))}

          <div className="mt-16">
            <h3 className="text-2xl font-extrabold text-gray-900 mb-6">Other Articles</h3>
            <div className="grid md:grid-cols-2 gap-6">
              {others.map((a) => (
                <Link to={`/articles/${a.slug}`} key={a.slug} className="flex gap-4 bg-[#fbf6ee] rounded-2xl p-4 hover:shadow-lg transition-shadow">
                  <img src={a.image} alt={a.title} className="w-28 h-28 rounded-xl object-cover" />
                  <div>
                    <p className="text-xs text-gray-500 mb-1">{a.day} {a.month} · {a.author}</p>
                    <h4 className="font-bold text-gray-900 hover:text-[#b81d24] transition-colors">{a.title}</h4>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
